import { useSelector } from "react-redux";

import { useRecentEventForCurrentMode } from "../../../../../hooks/useRecentEventForCurrentMode";
import {
  selectFocusedEvent,
  selectIsSoftball,
} from "../../../../../store/slices/socket/selectors";
import type { RootState } from "../../../../../store/store";
import { LandingPointVis } from "../../svg/LandingPointVis";
import { SoftballLandingPointVis } from "../../svg/SoftballLandingPointVis";

interface Props {
  style?: React.CSSProperties;
}

export const LandingVis = ({ style }: Props) => {
  const { isViewingPreviousEvent } = useSelector(
    (state: RootState) => state.socket,
  );
  const focusedEvent = useSelector(selectFocusedEvent);
  const recentEvent = useRecentEventForCurrentMode();
  const isSoftball = useSelector(selectIsSoftball);

  // Toggle data based on if we are viewing a previous event or current event
  const hit_data = isViewingPreviousEvent
    ? focusedEvent.hit_data
    : recentEvent.hit_data;

  const VisComponent = isSoftball ? SoftballLandingPointVis : LandingPointVis;

  return (
    <VisComponent
      style={style ? style : {}}
      xFeet={hit_data?.yt_GroundLocationXFeet}
      yFeet={hit_data?.yt_GroundLocationYFeet}
    />
  );
};
